/* cart-drawer.js
  - Handles opening/closing drawer
  - Renders cart from /cart.js
  - Adds items via AJAX (hooks into forms/buttons)
  - Updates quantities, removes items via /cart/change.js
*/

(function(){
  const drawerEl = document.getElementById('cart-drawer');
  const contentEl = document.getElementById('cart-drawer-content');
  const totalEl = document.getElementById('cart-drawer-total');
  const cartCountEl = document.getElementById('cart-count');
  const cartLinks = document.querySelectorAll(".site-header__link.site-header__cart");


  // Utility: format money (Shopify returns cents in cart.total_price? It's in cents)
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '$0.00';
    return (cents / 100).toLocaleString(undefined, { style:'currency', currency:'USD' }); // change currency if needed
  }

  // Open / close
  function openDrawer() {
    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add("cart-open");
    // prevent scroll
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawerEl.classList.add('is-closing');

    // Wait for transition (match CSS duration)
    setTimeout(() => {
      drawerEl.classList.remove('is-open', 'is-closing');
      drawerEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      document.documentElement.style.overflow = '';
    }, 400); // match CSS transition duration (0.4s)
  }

  // Click Cart icon to open drawer
  cartLinks.forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();
      openDrawer();
    });
  });
  

  // Update header cart icon count (assumes you have element with .site-header__cart-count)
  function updateCartIcon(count) {
    // update our small count in drawer
    if (cartCountEl) cartCountEl.textContent = count;

    // if your header has a specific count element, try updating it:
    const headerCount = document.querySelector('.site-header__cart-count');
    if (headerCount) headerCount.textContent = count;
  }

  function renderCart(cart) {
  if (!contentEl) return;

  const footer = document.querySelector('.cart-drawer__footer');
  contentEl.innerHTML = '';

  // Handle empty cart
  if (!cart || !cart.items || cart.items.length === 0) {
    contentEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p> <div class="continue-shoping"><a href="/">Continue Shoping</a></div>';

    totalEl.textContent = '$0.00';
    updateCartIcon(0);

    // Hide footer (buttons and totals)
    if (footer) footer.style.display = 'none';
    return;
  }

  // Show footer when items exist
  if (footer) footer.style.display = 'block';

  // Build items list
  const list = document.createElement('div');
  list.className = 'cart-items';

  cart.items.forEach((item, index) => {
    const itemEl = document.createElement('div');
    itemEl.className = 'cart-item';
    itemEl.dataset.variantId = item.variant_id;
    itemEl.dataset.itemKey = item.key;

    itemEl.innerHTML = `
      <div class="cart-item__image">
        <a href="${item.url}">
          <img src="${(item.image || '').replace(/(\?|$)/,'?')}?width=160" alt="${escapeHtml(item.title)}" />
        </a>
      </div>
      <div class="cart-item__meta">
       <a href="${item.url}" class="cart-item__title">
  ${escapeHtml((item.product_title || item.title).split(' ').slice(0, 5).join(' '))}${(item.product_title || item.title).split(' ').length > 5 ? '…' : ''}
  ${item.variant_title && item.variant_title !== 'Default Title' ? `
  <div class="cart-item__variant">${escapeHtml(item.variant_title)}</div>
` : ''}
  </a>
        <div class="cart-item__price">${formatMoney(item.line_price)}</div>
      </div>
       <div class="qty qty-remove" data-index="${index}">
          <div class="qty-only">
           <button class="qty-decrease" aria-label="Decrease quantity">−</button>
          <input type="number" class="qty-input" min="0" value="${item.quantity}" />
          <button class="qty-increase" aria-label="Increase quantity">+</button>
          </div>
        <div class="remove-only">
        <button class="cart-item__remove" title="Remove item"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M7.5 9.58334H12.5" stroke="#2E2E2E" stroke-width="1.25" stroke-linejoin="round"/>
  <path d="M8.75 12.9167H11.25" stroke="#2E2E2E" stroke-width="1.25" stroke-linejoin="round"/>
  <path d="M16.25 4.58334L15.4167 18.3333H4.58333L3.75 4.58334" stroke="#2E2E2E" stroke-width="1.25" stroke-linejoin="round"/>
  <path d="M1.66699 4.58332H6.66699M6.66699 4.58332L7.91699 1.66666H12.0837L13.3337 4.58332M6.66699 4.58332H13.3337M18.3337 4.58332H13.3337" stroke="#2E2E2E" stroke-width="1.25" stroke-linejoin="round"/>
</svg></button>
        </div>
        </div>
    `;

    list.appendChild(itemEl);
  });

  contentEl.appendChild(list);

  // Update totals and count
  totalEl.textContent = formatMoney(cart.total_price);
  updateCartIcon(cart.item_count);

  // Reattach quantity & remove listeners
  contentEl.querySelectorAll('.cart-item').forEach(itemEl => {
    const variantId = itemEl.dataset.variantId;
    const input = itemEl.querySelector('.qty-input');
    const btnInc = itemEl.querySelector('.qty-increase');
    const btnDec = itemEl.querySelector('.qty-decrease');
    const btnRemove = itemEl.querySelector('.cart-item__remove');

    btnInc && btnInc.addEventListener('click', () => {
      const newQty = parseInt(input.value, 10) + 1;
      updateQuantityByVariant(variantId, newQty);
    });
    btnDec && btnDec.addEventListener('click', () => {
      const newQty = Math.max(0, parseInt(input.value, 10) - 1);
      updateQuantityByVariant(variantId, newQty);
    });
    input && input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      updateQuantityByVariant(variantId, val);
    });
    btnRemove && btnRemove.addEventListener('click', () => {
      updateQuantityByVariant(variantId, 0);
    });
  });
}


  // Escape HTML for safe insertion
  function escapeHtml(string) {
    if (!string) return '';
    return String(string)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Fetch current cart and render
  async function fetchCartAndRender(openAfter=false) {
    try {
      const res = await fetch('/cart.js', { credentials:'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();
      renderCart(cart);
      if (openAfter) openDrawer();
    } catch (err) {
      console.error('fetchCartAndRender', err);
    }
  }

  // Add to cart via AJAX (variantId, quantity, formData allowed)
async function addToCartAjax(data) {
  try {
    let options = { 
      method: 'POST', 
      credentials: 'same-origin', 
      headers: {} 
    };

    if (data instanceof FormData) {
      options.body = data;
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }

    // Add item
    const res = await fetch('/cart/add.js', options);
    if (!res.ok) {
      const errText = await res.text();
      console.error('Add to cart failed', errText);
      return null;
    }

    // Fetch full updated cart JSON
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await cartRes.json();

    // Render your drawer/cart UI
    await fetchCartAndRender(true);

    return cart; // <-- IMPORTANT: return updated cart

  } catch (err) {
    console.error('addToCartAjax', err);
    return null;
  }
}


  // Update quantity by variant id (set to 0 to remove)
  // Shopify /cart/change.js supports id or line; we'll use id (variant_id) with quantity
  async function updateQuantityByVariant(variantId, quantity) {
    try {
      // endpoint expects {id: variantId, quantity: n}
      const payload = { id: variantId, quantity: parseInt(quantity, 10) };
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });
      if (!res.ok) {
        const txt = await res.text();
        console.error('change failed', txt);
        return;
      }
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart);
    } catch (err) {
      console.error('updateQuantityByVariant', err);
    }
  }

  // Attach to header cart link
  function initHeaderCartOpen() {
    // find anchor by selector provided: .site-header__link.site-header__cart
    const cartLink = document.querySelector('.site-header__link.site-header__cart') || document.querySelector('[data-cart-link]');
    if (cartLink) {
      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        fetchCartAndRender(true);
      });
    }
  }

  // Intercept add-to-cart forms / buttons on the page
 function interceptAddToCartButtons() {
  document.body.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    const formData = new FormData(form);
    let cart;
    if (formData.get('id')) {
      const payload = { id: formData.get('id'), quantity: formData.get('quantity') || 1 };
      cart = await addToCartAjax(payload);
    } else {
       cart = await addToCartAjax(formData);
    }
     if (cart) updateCartCount(cart);
  });

  // Also catch click-based buttons with data attributes
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart], .add-to-cart');
    if (!btn) return;

    e.preventDefault();
    const variant = btn.dataset.variant || btn.getAttribute('data-variant-id');
    const qty = btn.dataset.qty || 1;
    if (!variant) return;

    await addToCartAjax({ id: variant, quantity: parseInt(qty, 10) });
  });
}

function updateCartCount(cart) {
  const count = cart.item_count;
  const cartIndicator = document.querySelector('.site-header__cart-indicator');
  if (cartIndicator) cartIndicator.textContent = count;
}


  // Close triggers
  function initCloseTriggers() {
    drawerEl.addEventListener('click', (e) => {
      const closeSel = e.target.closest('[data-close-cart]');
      if (closeSel) closeDrawer();
    });
    // Esc key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawerEl.classList.contains('is-open')) closeDrawer();
    });
  }

  // Initialize
  function init() {
    // Wire up header toggle, add-to-cart intercepts, close
    initHeaderCartOpen();
    interceptAddToCartButtons();
    initCloseTriggers();

    // Optionally: on page load, fetch cart to update icon
    fetch('/cart.js', { credentials:'same-origin' })
      .then(r => r.json())
      .then(cart => {
        updateCartIcon(cart.item_count || 0);
        // we won't render drawer until user opens or adds
      }).catch(()=>{});
  }

  // run when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
